<template>
  <div>
    <div class="container">
      <el-row>
        <el-col :span="24"
                style="justify-content:flex-end">
          <el-upload class="upload-demo"
                     action
                     :show-file-list="false"
                     :http-request="uploadfile">
            <el-button size="mini"
                       v-if="show($store.state.menuList.dyxxlist,'import')"
                       type="primary">导入</el-button>
          </el-upload>
          <el-button type="primary"
                     style="margin-left:20px"
                     size="mini"
                     v-if="show($store.state.menuList.dyxxlist,'export')"
                     @click="exportMethod('https://c.cesc-energy.com/service/clientVolInfo/export/'+id,'电压信息.xlsx')">导出数据</el-button>
                               <el-button type="primary"
                     style="margin-left:20px"
                     size="mini"
                     v-if="show($store.state.menuList.dyxxlist,'exportT')"
                     @click="exportMethod('https://c.cesc-energy.com/service/clientVolInfo/export/template/'+id,'电压信息.xlsx')">导出模板</el-button>
          <el-button type="primary"
                     style="margin-left:20px"
                     @click="check1"
                     v-if="show($store.state.menuList.dyxxlist,'add')"
                     size="mini">新增</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-table border
                  ref="multipleTable"
                  :data="tableData.slice((current-1)*10,current*10)"
                  @selection-change="handleSelectionChange"
                  tooltip-effect="dark"
                  style="width: 100%">
          <el-table-column type="selection">
          </el-table-column>
          <el-table-column label="客户变压器编号">
            <template slot-scope="scope">{{ scope.row.transformerNo }}</template>
          </el-table-column>
          <el-table-column prop="transformerType"
                           label="变压器型号">
          </el-table-column>
          <el-table-column prop="transformerCapacity"
                           label="变压器容量">
          </el-table-column>
          <el-table-column prop="volLevel"
                           label="变压器电压等级">
            <template slot-scope="scope">
              <span v-if="scope.row.volLevel==1">不满1kV</span>
              <span v-if="scope.row.volLevel==2">1-10kV</span>
              <span v-if="scope.row.volLevel==3">35kV</span>
              <span v-if="scope.row.volLevel==4">11kV</span>
              <span v-if="scope.row.volLevel==5">110kV</span>
              <span v-if="scope.row.volLevel==6">220kV及以上</span>
            </template>
          </el-table-column>
          <el-table-column prop="address"
                           label="操作"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text"
                         v-if="show($store.state.menuList.dyxxlist,'edit')"
                         @click="check(scope.row, scope.row.volInfoId)"
                         size="small">编辑</el-button>
              <el-button type="text"
                         size="small"
                         v-if="show($store.state.menuList.dyxxlist,'delete')"
                         @click="deleteTable(scope.$index, tableData,scope.row.volInfoId)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px">
          <el-checkbox v-model="checked"
                       @change="toggleAllSelection"
                       style="margin-right:20px">全选</el-checkbox>
          <el-button @click="deleteTables"
                     type="danger">批量删除</el-button>
          <div class="pagination">
            <el-pagination @current-change="handleCurrentChange"
                           :current-page="current"
                           :page-size="10"
                           background
                           layout="total, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getClientVolInfos, deleteClientVolInfos, deletesClientVolInfos, postClientVolInfosFile, getmenusubmenu } from '../../API'
import { parantId } from '../../util/parantId'
import { show } from '../../util/show'
import exportMethod from '../../util/util'
export default {
  data () {
    return {
      checked: false,
      tableData: [],
      total: 0,
      current: 1,
      dialogFormVisible: false,
      multipleSelection: [],
      id: localStorage.getItem("id"),
    }
  },
  created () {
    getClientVolInfos(localStorage.getItem('id')).then(res => {
      if (res.code === 0) {
        this.tableData = res.data;
        this.total = res.data.length
      }
    })
    parantId(this.$store.state.permissionList.data, this.$route.path, this.$store)
    if (this.$store.state.parantId.parantId) {
      getmenusubmenu(this.$store.state.parantId.parantId).then(res => {
        if (res.code === 0) {
          this.$store.commit('menuList/COMMIT_DATA', { name: 'dyxxlist', data: res.data })
        }
      })
    }

  },
  watch: {
    "$store.state.parantId.parantId" (newval, olval) {
      getmenusubmenu(newval).then(res => {
        if (res.code === 0) {
          this.$store.commit('menuList/COMMIT_DATA', { name: 'dyxxlist', data: res.data })
        }
      })
    },
  },
  methods: {
    show,
    exportMethod,
    uploadfile (item) {
      let fileObj = item.file
      let name = fileObj.name;
      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(name)) {
        this.$notify.error({
          title: "错误",
          message: "上传文件只能为excel文件，且为xlsx,xls格式",
        });
        return false;
      }
      const form = new FormData()// FormData 对象
      form.append('file', fileObj)// 文件对象  'upload'是后台接收的参数名
      postClientVolInfosFile(form).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
        }
      })
    },
    toggleAllSelection () {
      this.$refs.multipleTable.toggleAllSelection()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    check (row, id) {
      this.$router.push({ path: '/CustomerManagement/dyxxxg' })
      localStorage.setItem("volInfoId", id)
    },
    check1 (row, id) {
      this.$router.push({ path: '/CustomerManagement/dyxxxg' })
      localStorage.removeItem("volInfoId")
    },
    deleteTable (index, rows, id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.splice(index, 1);
        deleteClientVolInfos(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteTables () {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = []
        for (let i = 0; i < this.multipleSelection.length; i++) {
          params.push(this.multipleSelection[i].volInfoId)
        }
        deletesClientVolInfos(params).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.current = 1,
              getClientVolInfos(localStorage.getItem('id')).then(res => {
                if (res.code === 0) {
                  this.tableData = res.data;
                  this.total = res.data.length
                }
              })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleCurrentChange (val) {
      this.current = val
    },
    onSubmit () {
      let params = this.formInline
      params.current = this.current
      getClientPage(this.formInline).then(res => {
        if (res.code === 0) {
          this.total = res.data.total;
          this.current = res.data.current;
          this.tableData = res.data.records
        }
      })
    },
    handleClick (row) {
      console.log(row);
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
  border: none;
  background-color: #fff;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}

/deep/ .el-table th.is-leaf {
  background-color: rgb(249, 250, 252);
}
.el-col {
  height: 40px;
  align-content: center;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666666;
}
</style>